export const lorem = require("js-util/lib/lorem").default;
export const css = require("js-util/lib/react-css").default;
export const PropTypes = require("react-schema").PropTypes;
